export default "__VITE_ASSET__BGyFj4f3__"